import {lazy} from "react";

export const Header = lazy(() => import('../interface/cabinet/header/Header'));
export const AuthLayout = lazy(() => import('./AuthLayout/AuthLayout'));
export const Cabinet = lazy(() => import('../pages/Cabinet/Cabinet'));
export const Cohort = lazy(() => import('../pages/Cabinet/Cohort'));
export const UnexpectedError = lazy(() => import('../interface/error/UnexpectedError/index'));
export const Analytics = lazy(() => import('#app/pages/Cabinet/Analytics'));
